module.exports = __webpack_public_path__ + "img/GH-kyujin-top-043.ebf5b1dd.webp";